import React from 'react';
import { FormField, Multiselect } from '@amzn/awsui-components-react-v3/polaris';

/**
 * Picks the base-rate arcs a model leaves out, by arc key. Used by the pricing model and scoping
 * model pages, with options from pricingModels.arcOptions.
 */

interface ExcludedArcsFieldProps {
  options: { label: string; value: string }[];
  selected: string[];
  description: string;
  errorText?: string;
  disabled: boolean;
  onChange: (selected: string[]) => void;
}

const ExcludedArcsField = ({
  options,
  selected,
  description,
  errorText,
  disabled,
  onChange,
}: ExcludedArcsFieldProps): JSX.Element => {
  const selectedArcs = new Set(selected);
  return (
    <FormField
      id="excludedArcs-field"
      label="Excluded arcs"
      description={description}
      errorText={errorText}
    >
      <Multiselect
        id="excludedArcs"
        options={options}
        selectedOptions={options.filter(option => selectedArcs.has(option.value))}
        filteringType="auto"
        placeholder="Choose arcs"
        deselectAriaLabel={(option): string => `Remove ${option.label}`}
        invalid={Boolean(errorText)}
        disabled={disabled}
        onChange={({ detail }): void =>
          onChange(detail.selectedOptions.map(option => option.value as string))
        }
      />
    </FormField>
  );
};

export default ExcludedArcsField;
